import type { FaireProductEntity } from "../../entity_types/product";

export const p_j268csnvjg: FaireProductEntity = {
  token: "p_j268csnvjg",
  type: "product",
  name: "Chamomile x Lavender Herbal Blend | 2oz - 1 KG | Bulk Tea",
  brandName: "Tree Fifty Four",
  imageUrl:
    "https://cdn.faire.com/fastly/ab3f43e6bee91eb88fec769021203706b8e32d98fc3a365319f90eb3a898dbc5.jpeg",
  priceDollars: 7.05,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/48b3b20cbedc1af6c05890ae2429bc4680dd169b158544bba1186e89d9e45c5f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
